import VueRouter from 'vue-router';
import Vue from 'vue';

Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    routes: [
        // ログイン
        {
            path: '/login',
            name: 'login',
            meta: { bodyClass: 'login' },
            component: require('./login/Index.vue').default
        },
        // なりすましログイン
        {
            path: '/impersonation-login/:master_user_id/:login_user_id',
            name: 'impersonation-login',
            meta: { bodyClass: 'impersonation-login' },
            component: () => import('./impersonation-login/Index.vue')
        },
        // パスワードの再発行
        {
            path: '/password/reissue',
            name: 'password-reissue',
            meta: { bodyClass: 'password-reissue' },
            component: require('./password-reissue/Index.vue').default
        },
        // パスワードの再発行（メール送信後の完了ページ）
        {
            path: '/password/reissue-done',
            name: 'password-reissue-done',
            meta: { bodyClass: 'password-reissue-done' },
            component: require('./password-reissue/Done.vue').default
        },
        // 新しいパスワードの設定
        {
            path: '/password/reissue/reset/:token',
            name: 'password-reissue-reset',
            meta: { bodyClass: 'password-reissue-reset' },
            component: require('./password-reissue/Reset.vue').default
        },
        // ユーザー新規登録パスワードの設定
        {
            path: '/password/new/:token',
            name: 'password-new',
            meta: { bodyClass: 'password-new' },
            component: require('./password-new/Index.vue').default
        }
    ]
});
